import { DateTime } from 'luxon';
import type { Status } from '@library/types/projection';
import type { TradingTeamBulkActions } from '@bo-hooks/trading/useTradingTeamBulkActions';
import { TradingTeamHeaderDatePicker } from '@bo-components/trading/games/TradingTeamHeaderDatePicker';

export interface TradingTeamHeaderDatePickersProps {
  boardStatus: Status;
  boardTimeString?: string;
  displayTimeString?: string;
  disabled?: boolean;
  standardStartTimes: Array<string>;
  tradingTeamActions: Omit<TradingTeamBulkActions, 'handleDelay'>;
  uniqueStartTimes: Array<string>;
  isDisplayTimeVisible?: boolean;
}

export const TradingTeamHeaderDatePickers = ({
  boardStatus,
  boardTimeString = undefined,
  displayTimeString = undefined,
  disabled = undefined,
  standardStartTimes,
  tradingTeamActions,
  uniqueStartTimes,
  isDisplayTimeVisible = false
}: TradingTeamHeaderDatePickersProps) => {
  const {
    handleChangeBoardTime,
    handleChangeStartTime,
    handleChangeDisplayTime
  } = tradingTeamActions;

  const moreThanOneStartTimeValidation = standardStartTimes?.length > 1;

  const showBulkStartTime = standardStartTimes?.length > 0;
  const [startTimeString] = showBulkStartTime
    ? standardStartTimes
    : uniqueStartTimes;

  return (
    <div className="flex gap-2">
      <TradingTeamHeaderDatePicker
        label="Board Time"
        dateTimeString={boardTimeString}
        onChange={handleChangeBoardTime}
        status={boardStatus}
        maxDate={DateTime.fromISO(startTimeString)}
        disabled={disabled}
      />

      <TradingTeamHeaderDatePicker
        label="Start Time"
        dateTimeString={startTimeString}
        onChange={handleChangeStartTime}
        disabled={disabled}
        moreThanOneStartTimeValidation={moreThanOneStartTimeValidation}
        uniqueStartTimes={uniqueStartTimes}
        format="t ZZZZ"
      />

      {isDisplayTimeVisible && (
        <TradingTeamHeaderDatePicker
          label="Display Time"
          dateTimeString={displayTimeString}
          onChange={handleChangeDisplayTime}
          disabled={disabled}
          format="t ZZZZ"
        />
      )}
    </div>
  );
};
